import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { focusManager } from '@accedo/vdkweb-navigation';
import classNames from 'classnames';
import { customRoutes, imgixTileResizeParameters } from '#/config/constants';
import getVw from '#/utils/getVw';
import imgixUrl from '#/utils/imgix';
import styles from './showcard.scss';
import { isWorkstation } from '#/utils/componentStyleConfig';
import { FocusDiv } from '#/widgets/ui';
import tileBgSrc from '#/static/images/background-images/ShowTileGradation.png';

const Container = ({
  nav,
  children,
  className,
  onClick,
  onFocus,
  onMouseOver,
  style,
  ariaLabel,
}) => {
  return !isWorkstation() ? (
    <FocusDiv
      nav={nav}
      className={className}
      classNameFocused={styles.focused}
      onClick={onClick}
      style={style}
      ariaLabel={ariaLabel}
      onFocus={onFocus}
    >
      {children}
    </FocusDiv>
  ) : (
    <div
      onClick={onClick}
      onMouseOver={onMouseOver}
      className={className}
      style={style}
    >
      {children}
    </div>
  );
};

const FocusContainer = Container;

const ShowCard = ({
  nav = {},
  id,
  imgUrl,
  name,
  hero = false,
  roundedCorners = true,
  className,
  onItemFocus,
  history,
  playlistId = '0',
  ariaLabel,
}) => {
  const imgSrc = useMemo(() => {
    let newUrl = '';
    if (!hero && isWorkstation()) {
      newUrl = `linear-gradient(
      225deg
      , transparent, rgba(0, 0, 0, 0.6)), `;
    }
    if (imgUrl) {
      return `${newUrl}url(${imgixUrl(
        imgUrl,
        imgixTileResizeParameters.SHOWS,
      )})`;
    }
    return 'black';
  }, [imgUrl, hero]);
  const onFocus = useCallback(() => {
    if (onItemFocus) {
      onItemFocus(nav.id);
    }
    focusManager.changeFocus(nav.id);
  }, []);

  return (
    <>
      <FocusContainer
        nav={nav}
        className={classNames(styles.card, className, {
          [styles.isTv]: !isWorkstation(),
          [styles.heroShow]: hero,
        })}
        onClick={() => {
          const pathname =
            playlistId !== '0'
              ? `${customRoutes.SHOW_DETAILS}/${id}/${playlistId}`
              : `${customRoutes.SHOW_DETAILS}/${id}`;
          history.push({
            pathname,
            state: {
              returnFocusId: nav.id,
            },
          });
        }}
        onMouseOver={!isWorkstation() ? () => {} : onFocus}
        onFocus={onFocus}
        style={{
          borderRadius: roundedCorners ? getVw(24) : '0px',
          outline: 'none',
        }}
        ariaLabel={ariaLabel || name}
      >
        <div
          className={styles.cardImageContainer}
          style={{ background: imgSrc }}
          aria-hidden="true"
        >
          {!hero &&
            (isWorkstation() ? (
              <div className={styles.textContainer}>
                <p className={styles.cardTitle}>{name}</p>
              </div>
            ) : (
              <div
                className={styles.tileBg}
                style={{ backgroundImage: `url(${tileBgSrc})` }}
              >
                <div className={styles.textContainer}>
                  <p className={styles.cardTitle}>{name}</p>
                </div>
              </div>
            ))}
        </div>
      </FocusContainer>
    </>
  );
};

Container.propTypes = {
  nav: PropTypes.object,
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseOver: PropTypes.func,
  style: PropTypes.object,
  ariaLabel: PropTypes.string,
};

ShowCard.propTypes = {
  // isFocused: PropTypes.bool,
  // onFocus: PropTypes.func,
  nav: PropTypes.object,
  id: PropTypes.string,
  imgUrl: PropTypes.string,
  name: PropTypes.string,
  hero: PropTypes.bool,
  roundedCorners: PropTypes.bool,
  className: PropTypes.string,
  onItemFocus: PropTypes.func,
  history: PropTypes.object,
  playlistId: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default withRouter(ShowCard);
